/** ``?reason=`` value when the Google account is tied to a different Flipmail user. */
export const MAILBOX_OAUTH_REASON_GOOGLE_ACCOUNT_IN_USE = "google_account_in_use";

export function mailboxOAuthErrorIsAccountInUse(reason) {
  return (reason || "").trim() === MAILBOX_OAUTH_REASON_GOOGLE_ACCOUNT_IN_USE;
}

/** Map ``?reason=`` from mailbox OAuth callback to customer-facing copy (no em dash). */
export function mailboxOAuthErrorMessage(reason) {
  const r = (reason || "").trim();
  if (r === "access_denied") {
    return "Google sign-in was cancelled.";
  }
  if (r === MAILBOX_OAUTH_REASON_GOOGLE_ACCOUNT_IN_USE) {
    return "This Google account is already linked to another Flipmail user. Sign in as that user or use a different Google account.";
  }
  if (r === "token_exchange") {
    return "Google sign-in could not be completed. Try again.";
  }
  if (r === "profile_fetch") {
    return "Could not read your Google profile. Try again.";
  }
  if (r === "missing_google_uid") {
    return "Could not verify your Google account. Try again.";
  }
  if (r === "invalid_state") {
    return "This sign-in link expired or was already used. Try connecting again.";
  }
  return "Could not connect mailbox. Try again.";
}
